import { Button, TextField } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import AddButton from "components/buttons/AddButton";
import React, { useContext } from "react";
import useSubcontractInvoice from "./useSubcontractInvoice";
import PostAddRoundedIcon from '@mui/icons-material/PostAddRounded';
import SubcontractExpenseDialog from "./SubcontractExpenseDialog";
import SearchButton from "components/buttons/SearchButton";
import ClearButton from "components/buttons/ClearButton";
import { Box } from "@mui/system";
import { useCallback } from "react";
import { subcontractInvoiceColNm } from "constants/subcontractConstant";
import DateTimeSelect from "components/DateTimeSelect";
import ComboBox from "components/ComboBox";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { scInvColumns } from "./columns";
import SubcontractPaymentVoucherDialog from "./SubcontractPaymentVoucherDialog";
import { initInvFilterData } from "./initData";
import { useMemo } from "react";
import { UserContext } from "contexts/UserContext";
import { ACC_TYP_EMP } from "constants/accountConstant";

const SubcontractInvoice = () => {

  const { user } = useContext(UserContext)
  const { state, fn } = useSubcontractInvoice()
  const { dialogExpenseOpen, filterData, selectedId, lastFilter, msData, dataTable, selectionModel
    , dialogPVOpen, selectedPVId } = state

  const selectedRow = useMemo(() => dataTable.filter(item => selectionModel.includes(item.ScInvId)), [dataTable, selectionModel])
  const filterProp = useCallback((name) => ({
    size: "small",
    varaint: "outlined",
    label: subcontractInvoiceColNm[name],
    sx: { width: 140 },
    value: filterData[name] || "",
    onKeyUp: e => { if (e.code === "Enter" || e.code === "NumpadEnter") { fn.searchScInvoice(filterData) } },
    onChange: (e) => { fn.setFilterData(oldState => ({ ...oldState, [name]: e.target.value || null })) }
  }), [filterData, fn])


  return (
    <BoxFC height="100%">
      <BoxFR>
        <Box flex={1} />
        {user.AccTypId === ACC_TYP_EMP ?
          <ComboBox options={msData.subContractCombo} label="รถร่วม" sx={{ width: 150 }}
            selectedId={filterData.ScId} setSelectedId={id => fn.setFilterData(o => ({ ...o, ScId: id || null }))} />
          : null
        }
        <TextField {...filterProp("XpssDocNum")} />
        <TextField {...filterProp("ScInvNo")} />
        <DateTimeSelect
          sx={{ width: 153 }}
          label="วันที่ใบแจ้งหนี้"
          start={filterData.ScInvDteSt}
          end={filterData.ScInvDteEn}
          setSelectDate={(start, end) => { fn.setFilterData(o => ({ ...o, ScInvDteSt: start, ScInvDteEn: end })) }}
          getData={() => { fn.searchScInvoice(filterData) }} />

        <TextField {...filterProp("JobOrdId")} type="number" />
        <TextField {...filterProp("JobNo")} />
        <TextField {...filterProp("Bkg")} />
        <TextField {...filterProp("Loc")} />
        <TextField {...filterProp("ContNo")} />
        <DateTimeSelect
          sx={{ width: 153 }}
          label="วันที่นัดเข้าโรงงาน"
          start={filterData.AptTmSt}
          end={filterData.AptTmEn}
          setSelectDate={(start, end) => { fn.setFilterData(o => ({ ...o, AptTmSt: start, AptTmEn: end })) }}
          getData={() => { fn.searchScInvoice(filterData) }} />
        <SearchButton onClick={() => fn.searchScInvoice(filterData)} />
        <ClearButton onClick={() => fn.setFilterData(initInvFilterData)} />
      </BoxFR>
      <BoxFR>

        <AddButton onClick={fn.onAddButtonClick}>เพิ่ม Invoice รถร่วม</AddButton>
        {user.AccTypId === ACC_TYP_EMP ?
          <Button variant="contained" onClick={fn.openPVDialog}><PostAddRoundedIcon sx={{ mr: 1 }} />
            สร้างใบสำคัญจ่าย
          </Button> : null
        }
      </BoxFR>
      <Box mt={2} flex={1}>
        <DataGridCellExpand
          checkboxSelection
          disableSelectionOnClick
          selectionModel={selectionModel}
          onSelectionModelChange={fn.handleSelectionModelChange}
          hideFooter
          rows={dataTable}
          columns={scInvColumns(fn.handlePVNoClick)}
          onRowDoubleClick={(params, event, detail) => fn.openExpenseDialog(params.id)} />
      </Box>
      <SubcontractExpenseDialog
        selectedId={selectedId}
        dialogOpen={dialogExpenseOpen}
        lastFilter={lastFilter}
        setDialogOpen={fn.setDialogExpenseOpen}
        onFinish={fn.onExpenseDailogFinish} />
      <SubcontractPaymentVoucherDialog
        selectedId={selectedPVId}
        selectedRows={selectedRow}
        dialogOpen={dialogPVOpen}
        setDialogOpen={fn.setDialogPVOpen}
        onFinish={fn.onExpenseDailogFinish} />
    </BoxFC>
  )
}

export default React.memo(SubcontractInvoice)